import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import SwaggerUI from 'swagger-ui'

import './assets/main.css'

const app = createApp(App)

app.use(router)

app.mount('#app')

SwaggerUI({
    dom_id: '#swagger-docs'
})